'use client';

import { CSSProperties } from 'react';

import { GuideContentWrap } from './GuideCategory';
import { Wrapper, ProductHeader, Content } from './Header';
import { ManualMainMain, ManualMain } from '@/ui/components/Manual/manual.styled';
import ManualLayout from '@/ui/components/Manual/ManualLayout';

const styles: { [key: string]: CSSProperties } = {
  list: {
    borderTop: `1px solid #e0e0e0`,
    display: 'flex',
    flexFlow: 'column',
    margin: '20px 0 0',
    padding: 0,
  },
  line: {
    alignItems: 'center',
    borderBottom: `1px solid #e0e0e0`,
    display: 'flex',
    gap: '20px',
    padding: '20px',
  },
};

export default function Loading() {
  return (
    <ManualLayout isPageLoading>
      <ManualMainMain>
        <ManualMain
          style={{
            overflowY: 'auto',
          }}
        >
          <GuideContentWrap>
            <Wrapper $isTabOpen={false}>
              <ProductHeader>
                <div className="pulse" style={{ marginLeft: 'auto', marginRight: 'auto' }} />
              </ProductHeader>
              <Content>
                <div className="pulse" style={{ height: '52px' }} />
                <div className="pulse" style={{ height: '52px' }} />
                <div className="pulse" style={{ height: '36px', width: '150px' }} />
                <div className="pulse" style={{ height: '36px', width: '250px' }} />
              </Content>
            </Wrapper>

            <div style={{ marginTop: '30px' }}>
              <div className="pulse" style={{ height: '26px', width: '100px' }} />

              <div style={styles.list}>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(number => {
                  return (
                    <div style={styles.line} key={number}>
                      <div className="pulse" style={{ height: '28px' }} />
                    </div>
                  );
                })}
              </div>
            </div>

            <div style={{ height: '50px' }} />
          </GuideContentWrap>
        </ManualMain>
      </ManualMainMain>
    </ManualLayout>
  );
}
